import React, { memo } from 'react';
import { View } from 'react-native';
import { useMarginBottom } from 'hooks/useMarginBottom';
const SafeAreaBottom = ({ children, style, }) => {
    const marginBottom = useMarginBottom();
    return <View style={[marginBottom, style]}>{children}</View>;
};
export default memo(SafeAreaBottom);
